module.exports = __webpack_public_path__ + "img/What.6c2ffccf.png";